angular.module('leanlaw').filter("tabFilter", [function () {
  return function (tabs, module) {
    return tabs.filter(tab => tab.show === undefined || tab.show === true || typeof tab.show === 'function' && tab.show(module));
  };
}]);